import * as React from "react";
// import { TO_CATEGORIES, TO_HOME, TO_TAGS } from "../../../constants";
// import { LinkContainer } from "./container";
// import { NavigationLink } from "./link";
import { FooterTopWrapper } from "./wrapper";

export const FooterTop = () => {
  return (
    <FooterTopWrapper>
      {/* <LinkContainer>
        <NavigationLink to="/" title={TO_HOME}>
          Home
        </NavigationLink>
      </LinkContainer>
      <LinkContainer>
        <NavigationLink to="/blog" title={TO_HOME}>
          Blog
        </NavigationLink>
      </LinkContainer>
      <LinkContainer>
        <NavigationLink to="/categories" title={TO_CATEGORIES}>
          Categories
        </NavigationLink>
      </LinkContainer>
      <LinkContainer>
        <NavigationLink to="/tags" title={TO_TAGS}>
          Tags
        </NavigationLink>
      </LinkContainer> */}
    </FooterTopWrapper>
  );
};
